export default (value) => {
  // comic(stripNumber)_characters_(stripName).png
  const patterns = {
    fileName: /comic(\d+)_.+_(.+)\..+/,
    stripName: /[A-Z]*[^A-Z]+/g,
  };
  const parts = value.match(patterns.fileName);
  const stripNumber = parts && parseInt(parts[1], 10);
  const stripName = parts && parts[2];
  const wordsInStripName = stripName && stripName.match(patterns.stripName);
  return {
    number: stripNumber,
    name: wordsInStripName ? wordsInStripName.join(' ') : stripName,
  };
};
